import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const addAddition = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.PayrollAddition, input);
  return data;
};

export const useAddAdditionMutation = () => {
  return useMutation({
    mutationFn: addAddition,
  });
};

const updateAddition = async (input) => {
  const data = await http_payroll.put(Api_EndPoints.PayrollAddition, input);
  return data;
};

export const useUpdateAdditionMutation = () => {
  return useMutation({
    mutationFn: updateAddition,
  });
};

const deleteAddition = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.PayrollAddition}?&code=${code}&CompanyCode=${companyCode}`
  );
  return data;
};

export const useDeletePayrollAdditionMutation = () => {
  return useMutation({
    mutationFn: deleteAddition,
  });
};
